module.exports = __webpack_public_path__ + "static/img/icon-word_filled.bf8259be.svg";